import styled from 'react-emotion';
const Quantity = styled('p') `
  font-size: ${({ theme }) => theme.fontSizes[1]};
  margin-left: 4px;
  color: #878787;
`;
export default Quantity;
//# sourceMappingURL=Quantity.js.map